import React from 'react'
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import ordersdetail from "../assets/images/order-detail.png";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ManageRight() {
  return (
    <div className='order-detail-main-outer'>
      <div className='order-detail-content'>
         <div className='dashbord-header'>
            <p className='title-dash'>Manage Address</p>
          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={profile} alt="" />
                  <div className="name-mail">
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <a className="dropdown-item" href="#">
                    Profile
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Support
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
         </div>
         <div className='outer-box-oc'>
               <div className='row'>
                    <div className='col-lg-7 col-12'>
                        <div className='address-manager'>
                          <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Address</h4>
                            </div>
                            <div className='sr-date pyment-invoice'>
                                <a href="#"><MoreVertIcon/></a>
                            </div>
                          </div>
                          <div className='billing-text'>
                            <div className='icon-info'>
                               <FmdGoodOutlinedIcon />
                               <p>15 Corner, Sector 10 Shopping Center Vijay Path Crossing, Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020</p>
                            </div>
                          </div>
                        </div>
                    </div>

                     <div className='col-lg-5 col-12'>
                        <div className='address-manager'>
                          <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Add Address</h4>
                            </div>
                          </div>
                          <div className='add-adres billing-text'>
                             <a href="#"><AddIcon/></a>
                          </div>
                        </div>
                    </div>
                    
                </div>
         </div>
      </div>
    </div>
  )
}


